<template>
  <div class="account-page py-4 mt-4">
    <div class="container">
      <div class="w-full main-card px-3 md:px-4 lg:px-5 py-4 lg:py-5 xl:py-7">
        <h1>Mass Communications</h1>
        <h2>Create a New Campaign</h2>
        <div>
          <Row class="mb-3">
            <Col :md="24">
              <CustumInput
                style="width: 100%"
                name="campaignName"
                :defaultData="null"
                :defaultError="null"
                label="Campaign Name"
                placeholder="Enter campaign name"
                :rules="{
                  required: true,
                  min: 3,
                }"
                @setInput="setInput"
              />
            </Col>
          </Row>
        </div>
        <div>
          <Row class="mb-3">
            <Col :md="24">
              <p>Campaign File<span class="red text-red-600">*</span>:</p>
              <CustumFileInput
                name="emails_file"
                placeholder="choose emails text file"
                accept=".txt"
                :rules="{
                  required: false,
                  min: 1,
                  max: 1,
                }"
                @setInput="setFileInput"
              >
                <PhFile :size="22" weight="duotone" />
              </CustumFileInput>
            </Col>
          </Row>
        </div>
        <div class="w-100">
          <Button
            block
            class="tailwind width-100"
            type="primary"
            :loading="loading"
            @click="createCampaign"
            >Create</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustumFileInput from '@/components/shared/form/CustumFileInput.vue';
import CustumInput from '@/components/shared/form/CustumInput.vue';
import campaignsApi from '@/services/apis/admin/campaigns.api';
import { Button, Col, message, Row } from 'ant-design-vue';
import { PhFile } from 'phosphor-vue';

export default {
  components: {
    CustumInput,
    Col,
    Row,
    Button,
    CustumFileInput,
    PhFile,
  },
  data() {
    return {
      campaign_name: null,
      file_content: null,
      loading: false,
    };
  },
  created() {},
  computed: {
    customEmailsQuery() {
      return this.$store.state.campaigns.oldCampaignsQuery;
    },
  },
  methods: {
    setInput(vals) {
      this.campaign_name = vals?.campaignName?.value || null;
    },
    setFileInput(val) {
      if (!val || !val.emails_file || !val.emails_file.value) return;

      const file = val.emails_file.value[0];
      if (!file) return;

      // Read the file content
      const reader = new FileReader();
      reader.onload = (e) => {
        const content = e.target.result;
        // emails may be separated by semicolons, commas or new lines
        this.file_content = content
          .split(/[;,\s]+/)
          .map((line) => line.trim())
          .filter((line) => line);
        // Use the content here
      };
      reader.readAsText(file); // For text files
    },
    async createCampaign() {
      if (!this.campaign_name || !this.file_content) return;
      this.loading = true;
      await campaignsApi.createCampaign({
        name: this.campaign_name,
        emails: this.file_content,
      });
      this.loading = false;

      this.customEmailsQuery?.refetch();
      this.campaign_name = null;
      this.file_content = null;
      message.success('Campaign created successfully');
      // Proceed with creating the campaign using this.campaign_name and this.file_content
    },
  },
};
</script>
